import {
    AmountWrapper,
    DenomBox,
    DenomBoxWrapper,
    HeaderParagraphText,
} from '@/src/modules/build-a-card/StyledComponents'
import { usePerfectGiftBoxContext } from '@/src/common/contexts/PerfectGiftBoxContext'
import { BaseSyntheticEvent } from 'react'
import { maxSingleCardLoad, minCardLoad } from '@/src/modules/checkout/strings'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { defaultDenominations } from '@/src/modules/build-a-card/constants'
import { validateDenomOnChange } from '@/src/modules/build-a-card/validations/validateDenom'
import RequiredAsterisk from '@/src/common/components/elements/Forms/RequiredAsterisk'
import { DenomInputWithLabel } from '@/src/common/components/elements/Forms/DenomInputWithLabel'

const DefaultDenominationOptions = () => {
    const { denomination, setDenomination, formErrors, setFormErrors } =
        usePerfectGiftBoxContext()
    return (
        <AmountWrapper>
            <HeaderParagraphText>
                Next, choose an amount for your gifts:
                <RequiredAsterisk />
            </HeaderParagraphText>
            <DenomBoxWrapper>
                {defaultDenominations.map((denom) => {
                    return (
                        <DenomBox
                            key={`${denom}-button`}
                            id={`${denom}-button`}
                            label={`$${denom}`}
                            onClick={() => {
                                const adjustedDenom = denom.toFixed(2)
                                validateDenomOnChange({
                                    denom: adjustedDenom,
                                    setDenomination,
                                    formErrors,
                                    setFormErrors,
                                    minDenom: minCardLoad,
                                    maxDenom: maxSingleCardLoad,
                                })
                            }}
                            variant={
                                Number(denomination) === denom
                                    ? 'graySquareButtonActive'
                                    : 'graySquareButton'
                            }
                            type={'button'}
                        />
                    )
                })}
            </DenomBoxWrapper>
            <DenomInputWithLabel
                name={'denomination'}
                label={'Custom Amount'}
                data-testid={'denomination'}
                placeholder={`Enter an amount $${minCardLoad} - $${maxSingleCardLoad}`}
                value={denomination}
                onChange={(e: BaseSyntheticEvent) => {
                    const denom = e.target.value
                    validateDenomOnChange({
                        denom,
                        setDenomination,
                        formErrors,
                        setFormErrors,
                        minDenom: minCardLoad,
                        maxDenom: maxSingleCardLoad,
                    })
                }}
                onBlur={() => {
                    // if denom set, adjust format to ###.##
                    if (denomination) {
                        setDenomination(parseFloat(denomination).toFixed(2))
                    }
                }}
                type={'number'}
                aria-placeholder={'Enter a custom amount'}
                min={minCardLoad}
                max={maxSingleCardLoad}
            />
            <FormErrorDisplay formErrors={formErrors} path={'denomination'} />
        </AmountWrapper>
    )
}

export default DefaultDenominationOptions
